// pages/Blogs.js
import React, { useState } from 'react';
import './Blogs.css';
import { FaArrowRight, FaCalendar, FaUser, FaTag, FaSearch, FaClock } from 'react-icons/fa';

const Blogs = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  const blogPosts = [
    {
      id: 1,
      title: "How to Start Your E-commerce Business in Pakistan",
      excerpt: "A complete guide to launching your online store, from product sourcing to marketing strategies tailored for Pakistani entrepreneurs.",
      category: "E-commerce Guide",
      date: "March 15, 2026",
      readTime: "8 min read",
      author: "Ahmed Raza",
      authorImage: "https://ui-avatars.com/api/?background=667eea&color=fff&name=Ahmed+Raza&size=40",
      image: "https://images.pexels.com/photos/2305098/pexels-photo-2305098.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: true
    },
    {
      id: 2,
      title: "Top 10 Digital Marketing Tips for Small Businesses",
      excerpt: "Boost your online presence with these proven digital marketing strategies that won't break the bank.",
      category: "Marketing",
      date: "March 10, 2026",
      readTime: "6 min read",
      author: "Sara Khan",
      authorImage: "https://ui-avatars.com/api/?background=764ba2&color=fff&name=Sara+Khan&size=40",
      image: "https://images.pexels.com/photos/2883049/pexels-photo-2883049.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    },
    {
      id: 3,
      title: "Why Mobile-First Design Matters for Your Store",
      excerpt: "Learn why optimizing your e-commerce website for mobile devices is crucial for conversions and customer satisfaction.",
      category: "Web Design",
      date: "March 5, 2026",
      readTime: "5 min read",
      author: "Usman Ali",
      authorImage: "https://ui-avatars.com/api/?background=25D366&color=fff&name=Usman+Ali&size=40",
      image: "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    },
    {
      id: 4,
      title: "Payment Gateway Options for Pakistani Businesses",
      excerpt: "Compare the best payment solutions available in Pakistan including EasyPaisa, JazzCash, and credit card processing.",
      category: "Payments",
      date: "February 28, 2026",
      readTime: "7 min read",
      author: "Fatima Zafar",
      authorImage: "https://ui-avatars.com/api/?background=FF5F35&color=fff&name=Fatima+Zafar&size=40",
      image: "https://images.pexels.com/photos/7567532/pexels-photo-7567532.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    },
    {
      id: 5,
      title: "Social Media Strategies to Drive Sales",
      excerpt: "Master Instagram, Facebook, and TikTok to turn followers into paying customers for your online store.",
      category: "Social Media",
      date: "February 22, 2026",
      readTime: "9 min read",
      author: "Hamza Ali",
      authorImage: "https://ui-avatars.com/api/?background=823FEB&color=fff&name=Hamza+Ali&size=40",
      image: "https://images.pexels.com/photos/267350/pexels-photo-267350.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: true
    },
    {
      id: 6,
      title: "Customer Support Best Practices for E-commerce",
      excerpt: "Build customer loyalty with exceptional support using WhatsApp, email, and live chat integration.",
      category: "Customer Service",
      date: "February 18, 2026",
      readTime: "6 min read",
      author: "Ayesha Malik",
      authorImage: "https://ui-avatars.com/api/?background=5AEA98&color=fff&name=Ayesha+Malik&size=40",
      image: "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    },
    {
      id: 7,
      title: "Product Photography Tips That Convert",
      excerpt: "Learn how to take stunning product photos that increase sales and build trust with your customers.",
      category: "Product Tips",
      date: "February 12, 2026",
      readTime: "5 min read",
      author: "Bilal Ahmed",
      authorImage: "https://ui-avatars.com/api/?background=FFE354&color=333&name=Bilal+Ahmed&size=40",
      image: "https://images.pexels.com/photos/1172869/pexels-photo-1172869.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    },
    {
      id: 8,
      title: "SEO Guide for Pakistani E-commerce Stores",
      excerpt: "Rank higher on Google and drive organic traffic with these local SEO strategies tailored for Pakistan.",
      category: "SEO",
      date: "February 8, 2026",
      readTime: "10 min read",
      author: "Dr. Noman",
      authorImage: "https://ui-avatars.com/api/?background=100F20&color=fff&name=Dr.+Noman&size=40",
      image: "https://images.pexels.com/photos/270404/pexels-photo-270404.jpeg?auto=compress&cs=tinysrgb&w=600",
      featured: false
    }
  ];

  const categories = ['All', 'E-commerce Guide', 'Marketing', 'Web Design', 'Payments', 'Social Media', 'Customer Service', 'Product Tips', 'SEO'];

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const featuredPosts = blogPosts.filter(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured);

  const handleReadMore = (postId) => {
    // Implement navigation to individual blog post
    console.log(`Navigate to blog post ${postId}`);
  };

  return (
    <div className="blogs-page">
      {/* Hero Section */}
      <section className="blogs-hero">
        <div className="blogs-container">
          <h1 className="blogs-hero-title">
            Insights & <span className="highlight">Inspiration</span>
          </h1>
          <p className="blogs-hero-subtitle">
            Expert tips, industry trends, and success stories to help your e-commerce business thrive.
          </p>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="blogs-filter-section">
        <div className="blogs-container">
          <div className="filter-wrapper">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search articles..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
            </div>
            <div className="category-filters">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Featured Posts Section */}
      {featuredPosts.length > 0 && searchTerm === '' && selectedCategory === 'All' && (
        <section className="featured-section">
          <div className="blogs-container">
            <div className="featured-header">
              <span className="featured-badge">Featured</span>
              <h2 className="section-title">Must-Read Articles</h2>
            </div>
            <div className="featured-grid">
              {featuredPosts.map((post) => (
                <div key={post.id} className="featured-card">
                  <div className="featured-image">
                    <img src={post.image} alt={post.title} />
                    <span className="category-tag">{post.category}</span>
                  </div>
                  <div className="featured-content">
                    <h3 className="featured-title">{post.title}</h3>
                    <p className="featured-excerpt">{post.excerpt}</p>
                    <div className="post-meta">
                      <div className="author-info">
                        <img src={post.authorImage} alt={post.author} className="author-avatar" />
                        <span className="author-name">{post.author}</span>
                      </div>
                      <div className="post-date">
                        <FaCalendar className="meta-icon" />
                        <span>{post.date}</span>
                      </div>
                      <div className="post-read-time">
                        <FaClock className="meta-icon" />
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                    <button className="read-more-btn" onClick={() => handleReadMore(post.id)}>
                      Read Article <FaArrowRight />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* All Posts Grid - Similar to StoreOptions features grid */}
      <section className="all-posts-section">
        <div className="blogs-container">
          <div className="posts-header">
            <h2 className="section-title">
              {searchTerm || selectedCategory !== 'All' ? 'Search Results' : 'Latest Articles'}
            </h2>
            { (searchTerm || selectedCategory !== 'All') && (
              <p className="results-count">Found {filteredPosts.length} articles</p>
            )}
          </div>
          
          <div className="posts-grid">
            {regularPosts.map((post, index) => (
              <div key={post.id} className="blog-card" style={{ animationDelay: `${index * 0.05}s` }}>
                <div className="blog-card-image">
                  <img src={post.image} alt={post.title} />
                  <span className="category-badge">{post.category}</span>
                </div>
                <div className="blog-card-content">
                  <h3 className="blog-title">{post.title}</h3>
                  <p className="blog-excerpt">{post.excerpt.substring(0, 100)}...</p>
                  <div className="blog-meta">
                    <div className="meta-item">
                      <FaUser className="meta-icon-small" />
                      <span>{post.author}</span>
                    </div>
                    <div className="meta-item">
                      <FaCalendar className="meta-icon-small" />
                      <span>{post.date}</span>
                    </div>
                    <div className="meta-item">
                      <FaClock className="meta-icon-small" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  <button className="blog-read-more" onClick={() => handleReadMore(post.id)}>
                    Read More <FaArrowRight />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <div className="no-results">
              <p>No articles found matching your criteria.</p>
              <button className="reset-btn" onClick={() => {
                setSearchTerm('');
                setSelectedCategory('All');
              }}>
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section - Newsletter */}
      <section className="newsletter-section">
        <div className="blogs-container">
          <div className="newsletter-card">
            <h3 className="newsletter-title">Stay Updated</h3>
            <p className="newsletter-text">
              Get the latest e-commerce tips and strategies delivered straight to your inbox.
            </p>
            <div className="newsletter-form">
              <input type="email" placeholder="Enter your email address" className="newsletter-input" />
              <button className="newsletter-btn">Subscribe <FaArrowRight /></button>
            </div>
            <p className="newsletter-note">No spam. Unsubscribe anytime.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blogs;